export const MAX_INPUT_WIDTH = 520;
